module.exports = __webpack_public_path__ + "img/p2.0209b4ab.png";